module.exports = __webpack_public_path__ + "media/images/logos/International-Business-Times_logo-653c2f2f57ada93fa610c246b880318b.svg";